import { render, staticRenderFns } from "./CourseWorkloadCircle.vue?vue&type=template&id=0cb6ce47&scoped=true"
import script from "./CourseWorkloadCircle.vue?vue&type=script&lang=js"
export * from "./CourseWorkloadCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb6ce47",
  null
  
)

export default component.exports